import Icon from './Icon';

const PracticeLightening = (props) => (
  <Icon
    viewBox="0 0 24 24"
    {...props}
    path="M17.2868 11.0933C17.2485 11.0034 17.1843 10.9268 17.1024 10.8734C17.0205 10.82 16.9246 10.7921 16.8268 10.7933H13.6735V6C13.6737 5.89859 13.643 5.79954 13.5855 5.71597C13.5281 5.63241 13.4465 5.5683 13.3518 5.53214C13.2571 5.49598 13.1536 5.48948 13.055 5.51351C12.9565 5.53753 12.8676 5.59095 12.8002 5.66667L6.80017 12.3733C6.73579 12.4453 6.69363 12.5344 6.67879 12.6298C6.66395 12.7253 6.67707 12.823 6.71655 12.9111C6.75604 12.9992 6.8202 13.074 6.90129 13.1265C6.98238 13.1789 7.07693 13.2068 7.17351 13.2067H10.3268V18C10.3264 18.102 10.3575 18.2017 10.416 18.2852C10.4745 18.3688 10.5575 18.4322 10.6535 18.4667C10.7474 18.5028 10.85 18.5094 10.9477 18.4856C11.0454 18.4618 11.1335 18.4086 11.2002 18.3333L17.2002 11.6267C17.2649 11.5558 17.3076 11.4677 17.323 11.3729C17.3384 11.2782 17.3258 11.181 17.2868 11.0933Z"
  />
);

export default PracticeLightening;
